import React from 'react';
import {css, cx, getSystemStyles} from '@packages/utilities/styled';
import type {ViewProps} from '../_types';

export const useView = ({
  className: classNameProp,
  /**
   * We are explicitly excluding the `style` prop from the props object because we are handling it separately.
   *
   * The `style` prop can update frequently, and we do not want to rerun our `systemStyles` or `cx` calculations unnecessarily.
   */
  style,
  htmlTranslate,
  ...props
}: ViewProps) => {
  const styleSystemClass = React.useMemo(() => getSystemStyles(props), [props]);

  const className = React.useMemo(
    () => cx(css(styleSystemClass), classNameProp),
    [styleSystemClass, classNameProp]
  );

  return React.useMemo(
    () => ({
      ...props,
      className,

      /**
       * Our `translate` prop is a CSS property that we are using to translate the element.
       * This conflicts with the HTML `translate` attribute.
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/translate
       */
      translate: htmlTranslate,

      style,
    }),
    [className, props, style, htmlTranslate]
  );
};
